// Ultimate Card Game (UCG) - hidden developer menu switch.
//
// The memory-probe overlay button and the A/B switches (js/ui/memProbe.js, js/ui/abFlags.js) are for the
// developer's own devices, not for alpha testers. They are hidden in Options until the header
// ("SYSTEM / OPTIONS") is tapped three times in quick succession; the same gesture hides them again.
// The choice is remembered in localStorage so it survives relaunches of the PWA.
//
// This only controls what the Options screen shows: the probe keeps recording and active A/B switches
// stay active (?ab=off clears them).

export const DEV_TOOLS_KEY = 'ucg_dev_tools';
export const DEV_TAPS = 3;
export const DEV_TAP_WINDOW_MS = 1200;

export function isDevToolsOn(storage) {
  try {
    return storage?.getItem?.(DEV_TOOLS_KEY) === '1';
  } catch {
    return false;
  }
}

export function setDevToolsOn(storage, on) {
  try {
    if (on) storage?.setItem?.(DEV_TOOLS_KEY, '1');
    else storage?.removeItem?.(DEV_TOOLS_KEY);
  } catch { /* private mode / quota: the choice just does not persist */ }
  return !!on;
}

// tap() is called for every click; the callback fires on the Nth tap that all landed within windowMs of
// the previous one, then the counter starts over.
export function createTapTrigger({ taps = DEV_TAPS, windowMs = DEV_TAP_WINDOW_MS, onTrigger, now = () => Date.now() } = {}) {
  let count = 0;
  let last = -Infinity;
  return function tap() {
    const t = now();
    count = t - last <= windowMs ? count + 1 : 1;
    last = t;
    if (count >= taps) {
      count = 0;
      last = -Infinity;
      onTrigger?.();
      return true;
    }
    return false;
  };
}
